var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m500.7 126.5.6 4.2c-6.2-22-22.9-38.9-44.1-45.1l-.4-.1c-39.9-10.8-200.5-10.8-200.5-10.8S96 74.5 55.7 85.5c-21.6 6.3-38.4 23.2-44.4 44.7l-.1.4c-14.9 77.9-15 171.5.7 254.9l-.7-4.2c6.2 22 22.9 38.9 44.1 45.1l.4.1c39.9 10.9 200.5 10.9 200.5 10.9s160.2 0 200.5-10.9c21.7-6.3 38.4-23.2 44.5-44.7l.1-.4c6.8-36.2 10.7-77.9 10.7-120.5V251.3c0-42.7-3.9-84.4-11.3-124.8zM205 333.9V178.3l133.7 77.9L205 333.9z",
    style: {
      fill: "#d1d1d1"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.b51b6ead51f4e2321f5a67475cbddb96.svg";
export { ForwardRef as ReactComponent };